import { useState } from "react";
import { BriefcaseMedical, Stethoscope, HeartPulse, Bone, UserCheck, Activity, Ambulance, HandHeart } from "lucide-react";

const PATHS = [
  { k: "prestatore", label: "Prestatore di servizio", desc: "Medici, infermieri, fisioterapisti, OSS, assistenti, ambulanze, badanti", Icon: BriefcaseMedical },
];
const CATS = {
  prestatore: [["medico", "Medico / Dottore", Stethoscope], ["infermiere", "Infermiere", HeartPulse], ["fisioterapista", "Fisioterapista", Bone],
    ["oss", "Operatore socio-sanitario (OSS)", UserCheck], ["assistente_infermieristico", "Assistente infermieristico", Activity],
    ["trasporto_infermi", "Servizio ambulanza / Trasporto infermi", Ambulance], ["badante", "Badante", HandHeart]],
};

const Step = ({ n, t }) => <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-rose-500">Passo {n} · {t}</p>;

function Card({ active, onClick, Icon, label, desc, testid }) {
  return (
    <button type="button" data-testid={testid} onClick={onClick} className={`flex items-start gap-3 rounded-2xl border p-3.5 text-left transition-colors ${active ? "border-rose-400 bg-emerald-50 shadow-sm" : "border-slate-200 bg-white hover:border-rose-200"}`}>
      <span className={`grid h-8 w-8 shrink-0 place-items-center rounded-lg ${active ? "bg-rose-500 text-white" : "text-slate-500"}`}><Icon className="h-4 w-4" /></span>
      <span><span className="block text-sm font-semibold text-slate-900">{label}</span>{desc && <span className="mt-0.5 block text-xs text-slate-500">{desc}</span>}</span>
    </button>
  );
}

export function OperatorPath({ onSelect }) {
  const [path, setPath] = useState("prestatore");
  const [cat, setCat] = useState("");
  return (
    <div className="space-y-4" data-testid="operator-path">
      <Step n={1} t="Percorso" />
      <div className="grid grid-cols-1 gap-3">
        {PATHS.map((p) => <Card key={p.k} testid={`operator-path-${p.k}`} active={path === p.k} onClick={() => { setPath(p.k); setCat(""); }} Icon={p.Icon} label={p.label} desc={p.desc} />)}
      </div>
      <Step n={2} t="Categoria professionale" />
      <div className="grid grid-cols-2 gap-3">
        {CATS[path].map(([k, l, I]) => <Card key={k} testid={`operator-cat-${k}`} active={cat === k} onClick={() => setCat(k)} Icon={I} label={l} />)}
      </div>
      <button type="button" data-testid="operator-continue-btn" disabled={!cat} onClick={() => onSelect(cat)} className="w-full rounded-full bg-rose-600 py-2.5 text-sm font-bold text-white transition-colors hover:bg-rose-700 disabled:opacity-40">Continua con i dati di accesso</button>
    </div>
  );
}
